import CommonModal from '../common/CommonModal'
import { AlertCircle, CheckCircle } from 'lucide-react'
import { Button } from '../ui/button'
import { Smile } from 'lucide-react'
import { isEmpty } from '@/utils/commonFunc'

const CommonCenterModal = ({
  open,
  onOpenChange,
  message,
  description,
  smilingEmoticon,
  error,
  noIcon,
  callNumber,
}: any) => {
  const handleRedirect = (e: any) => {
    e.preventDefault()
    if (typeof window !== 'undefined') {
      window.location.href = `tel:${callNumber}`
    }
  }
  const getIcon = () => {
    switch (true) {
      case !!error:
        return <AlertCircle size={48} className="text-danger-500 mx-auto mb-6 sm:mt-4" />
      case smilingEmoticon:
        return <Smile size={48} className="text-success-500 mx-auto mb-6 sm:mt-4" />
      case noIcon:
        return <></>
      default:
        return <CheckCircle size={48} className="text-success-500 mx-auto mb-6 sm:mt-4" />
    }
  }
  return (
    <CommonModal open={open} onOpenChange={onOpenChange}>
      <div>
        {getIcon()}

        {message && (
          <h2 className="text-heading-sm mb-2 text-center">{message}</h2>
        )}
        {description && (
          <p className="text-label-xs text-gray-700 text-center mb-8 w-4/5 mx-auto">
            {description}
          </p>
        )}
        <div className="flex flex-row gap-2">
          <Button
            variant="ghost"
            className="bg-gray-100 py-3 h-auto w-full text-gray-900"
            onClick={onOpenChange}
          >
            Close
          </Button>

          {!isEmpty(callNumber) && (
            <Button
              variant="agilus_primary"
              className="py-3 h-auto w-full"
              onClick={handleRedirect}
            >
              Call
            </Button>
          )}
        </div>
      </div>
    </CommonModal>
  )
}

export default CommonCenterModal
